import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone } from "lucide-react";

const cols = [
  {
    title: "Platform",
    items: [
      ["EHR + AI Scribe", "#modules"],
      ["PMS", "#modules"],
      ["RCM", "#modules"],
      ["HRMS", "#modules"],
      ["Secure Chat", "#modules"],
      ["Calls", "#modules"],
      ["Telehealth", "#modules"],
      ["Analytics", "#modules"],
    ],
  },
  {
    title: "Company",
    items: [
      ["AI Agents", "#agents"],
      ["Pricing", "#pricing"],
      ["Free AR Audit", "#ar-audit"],
      ["Contact Us", "#contact"],
    ],
  },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative z-10 bg-[#F2F8FC] border-t border-[#D8E6F1]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src="/astra-logo.png" alt="Astra" className="h-16 w-auto" />
            <p className="mt-6 text-[#51667A] max-w-xs leading-relaxed">
              The AI-native operating system for modern practices. EHR, PMS, RCM, HRMS, communication and analytics - in one place.
            </p>
            <p className="mt-8 font-mono text-[11px] tracking-[0.2em] uppercase text-[#93A5B5]">
              AstraAIOS.com
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#0C2A40] mb-5">
                {c.title}
              </h4>
              <ul className="space-y-3">
                {c.items.map(([label, href]) => (
                  <li key={label}>
                    <a href={href} className="text-sm text-[#51667A] hover:text-[#2880B8] transition-colors duration-300">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#0C2A40] mb-5">Access</h4>
            <ul className="space-y-3">
              <li><Link to="/login" className="text-sm text-[#51667A] hover:text-[#2880B8] transition-colors duration-300">Log In</Link></li>
              <li><a href="#book" className="text-sm text-[#51667A] hover:text-[#2880B8] transition-colors duration-300">Get a Demo</a></li>
              <li><a href="#pricing" className="text-sm text-[#51667A] hover:text-[#2880B8] transition-colors duration-300">Pricing</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#0C2A40] mb-5">Contact Us</h4>
            <div className="space-y-3 text-sm text-[#51667A]">
              <a href="mailto:Sales@astraaios.com" className="flex items-center gap-2 hover:text-[#2880B8] transition-colors"><Mail size={15} /> Sales@astraaios.com</a>
              <a href="tel:3214411398" className="flex items-center gap-2 hover:text-[#2880B8] transition-colors"><Phone size={15} /> 321-441-1398</a>
            </div>
            <a href="#book" className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#2880B8] px-5 py-3 font-mono text-[10px] uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#1F6EA1]">
              Get a Demo <ArrowRight size={14} />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#D8E6F1] flex flex-col md:flex-row justify-between gap-4">
          <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-[#93A5B5]">
            © {new Date().getFullYear()} Astra AIOS - All Rights Reserved
          </p>
          <div className="flex gap-6 font-mono text-[11px] tracking-[0.15em] uppercase text-[#51667A]">
            <span className="text-[#2880B8]">HIPAA Certified</span>
            <span>AES-256 Encrypted</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
